import { compareAsc, isBefore, isValid, sub } from "date-fns";
import { FormInputs } from "../../reducers/workoutReducer";
import { WorkoutFormModel } from "./transformers";

export const typeValidator = (state: WorkoutFormModel) => {
  const typeInput = state[FormInputs.type];
  const type = typeInput.input as string;
  if (!type) {
    typeInput.error = true;
    typeInput.message = "Välj typ av pass";
  } else {
    typeInput.error = false;
    typeInput.message = "";
  }
};

export const numberOfPlacesValidator = (state: WorkoutFormModel) => {
  const nrPlacesInput = state[FormInputs.numberOfPlaces];
  const nrPlaces = nrPlacesInput.input as number;
  if (!nrPlaces) {
    nrPlacesInput.error = true;
    nrPlacesInput.message = "Minst 1 plats";
  } else if (nrPlaces < 1) {
    nrPlacesInput.error = true;
    nrPlacesInput.message = "Minst 1 plats";
  } else {
    nrPlacesInput.error = false;
    nrPlacesInput.message = "";
  }
};

export const dateValidator = (state: WorkoutFormModel) => {
  const dateInput = state[FormInputs.date];
  const date = dateInput.input as Date;
  if (!date) {
    dateInput.error = true;
    dateInput.message = "Välj ett datum";
  } else if (compareAsc(date, sub(new Date(), { days: 1 })) === -1) {
    dateInput.error = true;
    dateInput.message = "Datumet har redan varit";
  } else {
    dateInput.error = false;
    dateInput.message = "";
  }
};

export const endTimeValidator = (state: WorkoutFormModel) => {
  const endTimeInput = state[FormInputs.endTime];
  const endTime = endTimeInput.input as Date;
  if (endTime.toString() === "Invalid Date") {
    endTimeInput.error = true;
    endTimeInput.message = "Ogiltigt format";
  } else if (!endTime) {
    endTimeInput.error = true;
    endTimeInput.message = "Välj en sluttid";
  } else if (!isValid(endTime)) {
    endTimeInput.error = true;
    endTimeInput.message = "Ogiltigt format";
  } else if (isBefore(endTime, state[FormInputs.startTime].input as Date)) {
    endTimeInput.error = true;
    endTimeInput.message = "Sluttid innan starttid";
  } else {
    endTimeInput.error = false;
    endTimeInput.message = "";
  }
};

export const startTimeValidator = (state: WorkoutFormModel) => {
  const startTimeInput = state[FormInputs.startTime];
  const startTime = startTimeInput.input as Date;
  if (startTime.toString() === "Invalid Date") {
    startTimeInput.error = true;
    startTimeInput.message = "Ogiltigt format";
  } else if (!startTime) {
    startTimeInput.error = true;
    startTimeInput.message = "Välj en sluttid";
  } else if (!isValid(startTime)) {
    startTimeInput.error = true;
    startTimeInput.message = "Ogiltigt format";
  } else if (isBefore(state[FormInputs.endTime].input as Date, startTime)) {
    startTimeInput.error = true;
    startTimeInput.message = "Starttid efter sluttid";
  } else {
    startTimeInput.error = false;
    startTimeInput.message = "";
  }
};

export const locationValidator = (state: WorkoutFormModel) => {
  const locationInput = state[FormInputs.location];
  const location = locationInput.input as string;
  if (!location) {
    locationInput.error = true;
    locationInput.message = "Välj en plats";
  } else if (!/^[a-öA-Ö0-9 .,\-/()]+$/.test(location)) {
    locationInput.error = true;
    locationInput.message = "Otillåtna tecken";
  } else if (location.length > 150) {
    locationInput.error = true;
    locationInput.message = "Max 150 tecken";
  } else {
    locationInput.error = false;
    locationInput.message = "";
  }
};

export const gearValidator = (state: WorkoutFormModel) => {
  const gearInput = state[FormInputs.gear];
  const gear = gearInput.input as string[];

  const specialChar = gear.find((g) => !/^[a-öA-Ö 0-9]+$/.test(g));
  if (specialChar) {
    gearInput.error = true;
    gearInput.message = "Specialtecken i " + specialChar;
  } else {
    gearInput.error = false;
    gearInput.message = "";
  }
};

export const creditsValidator = (state: WorkoutFormModel) => {
  const creditsInput = state[FormInputs.credits];
  const credits = creditsInput.input as any;

  if (!isFinite(credits)) {
    creditsInput.error = true;
    creditsInput.message = "Måste vara siffra"
  } else {
    creditsInput.error = false;
    creditsInput.message = ""
  }
}

export const validateAll = (state: WorkoutFormModel) => {
  const validators: ((state: WorkoutFormModel) => void)[] = [
    numberOfPlacesValidator,
    dateValidator,
    typeValidator,
    locationValidator,
    startTimeValidator,
    endTimeValidator,
    gearValidator,
  ];
  validators.forEach((validator) => {
    validator(state);
  });
  const errors = Object.values(state).filter((input) => input.error);
  return errors;
};
